import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { Calendar, Check, Clock, CreditCard, LoaderCircle, Lock, LucideAngularModule, Minus, Plus, X } from 'lucide-angular';
import { BillingBannerComponent } from './billing-banner/billing-banner.component';
import { BillingGateComponent } from './billing-gate/billing-gate.component';
import { PlanPickerComponent } from './plan-picker/plan-picker.component';

/**
 * Billing pop-ups and banners (story "Stripe Renewals and Upgrade Pop-up"): imported once by AppModule; AppComponent hosts
 * <vf-billing-gate> and <vf-billing-banner> so they cover every route.
 */
@NgModule({
    imports: [
        CommonModule,
        LucideAngularModule.pick({ Calendar, Check, Clock, CreditCard, LoaderCircle, Lock, Minus, Plus, X }),
    ],
    declarations: [PlanPickerComponent, BillingGateComponent, BillingBannerComponent],
    exports: [BillingGateComponent, BillingBannerComponent],
})
export class BillingModule {}
